import { klasses } from '@/constants/klasses'
import { Switch, Typography } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export const UserRoleGroup = ({ klassKey, defaultActions, title, description }) => {
  const { t } = useTranslation()
  const getTitle = (actionType, klassKey) => title || t(`userRole.actions.${actionType}.with`, { what: klasses[klassKey] })
  const getDescription = (actionType, klassKey) => description || t(`userRole.actions.${actionType}.description`, { what: klasses[klassKey] })
  const { values, setFieldValue } = useFormikContext()
  const permissionIndex = values.findIndex(value => value.klass === klassKey)

  const permission = values[permissionIndex]
  const permissionActions = permission?.actions || []
  const mergedActions = new Set(permissionActions.concat(defaultActions))
  const actions = Array.from(mergedActions).sort()

  const togglePermission = (actionArray, action) => {
    const index = actionArray.indexOf(action)
    const newActionArray = Array.from(actionArray)
    if (index > -1) {
      newActionArray.splice(index, 1)
    } else {
      newActionArray.push(action)
    }
    return newActionArray
  }

  const onPermissionChange = (event) => {
    const element = event.target
    const action = element.name
    const currentPermission = values[permissionIndex]

    const newPermission = Object.assign(
      {}, currentPermission,
      { actions: togglePermission(currentPermission.actions, action) }
    )

    setFieldValue(`[${permissionIndex}]`, newPermission)
  }

  return (
    <div className='flex flex-col gap-2 mb-5'>
      { klasses[klassKey] && <Typography className='text-xs font-bold text-gray-400' >{klasses[klassKey]}</Typography> }
      <div className='flex flex-col'>

        {actions.map((actionType) => (
          <>
            <div key={actionType + klassKey} className="grid grid-cols-12">
              <div className="col-span-9">
                <Typography color='gray' variant='paragraph' className='font-semibold'>{getTitle(actionType, klassKey)}</Typography>
                <Typography variant='small' className='text-gray-500'>{getDescription(actionType, klassKey)}</Typography>
              </div>

              <div className="col-span-3 self-center justify-self-end">
                <Switch
                  onChange={onPermissionChange}
                  name={actionType}
                  checked={permissionActions.includes(actionType)}
                />
              </div>
            </div>
            <hr className='my-4' />
          </>
        ))}
      </div>
    </div>
  )
}

UserRoleGroup.defaultProps = {
  title: '',
  description: '',
  actions: [],
}

UserRoleGroup.propTypes = {
  title: PropTypes.string,
  description:  PropTypes.string,
  actions: PropTypes.array
}
